/**
 * @generated SignedSource<<089cad850e696ba267efbd7808064bea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type utils_useGetURL_recording$data = {
  readonly __typename: "MeetingRecording";
  readonly id: string;
  readonly " $fragmentType": "utils_useGetURL_recording";
} | {
  readonly __typename: "MeetingRecordingClip";
  readonly id: string;
  readonly " $fragmentType": "utils_useGetURL_recording";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "utils_useGetURL_recording";
};
export type utils_useGetURL_recording$key = {
  readonly " $data"?: utils_useGetURL_recording$data;
  readonly " $fragmentSpreads": FragmentRefs<"utils_useGetURL_recording">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "utils_useGetURL_recording",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "MeetingRecording",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "MeetingRecordingClip",
      "abstractKey": null
    }
  ],
  "type": "MeetingRecordingInterface",
  "abstractKey": "__isMeetingRecordingInterface"
};
})();

(node as any).hash = "edb8049605f19dcae6bacac015eb0595";

export default node;
